import { DownloadResultManager } from "@/services/license/base/license-manager-abstractions";
import { ConvertBaseLicenseManager } from "@/services/license/base/convert-base-license-manager";
import { DuetsDownloadResultLimiter } from "@/services/license/license-limiters/download-result-limiters/duets-download-result-limiter";

export class DuetsLicenseManager
  extends ConvertBaseLicenseManager
  implements DownloadResultManager
{
  downloadResultLimiter = new DuetsDownloadResultLimiter();
}

const duetsLicenseManager = new DuetsLicenseManager();
export { duetsLicenseManager };
